import React from 'react';
import ValidationElement from '../ValidationElement';
import Text from '../Text';

export default class County extends ValidationElement {
  constructor(props) {
    super(props);

    this.handleError = this.handleError.bind(this);
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      code: `county.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    // Take the original and concatenate our new error values to it
    return this.props.onError(value, arr2);
  }

  render() {
    return (
      <div className="usa-form-control">
        <Text
          attribute={this.props.attribute}
          name={this.props.name}
          label={this.props.label}
          ariaLabel={this.props.ariaLabel}
          placeholder={this.props.placeholder}
          minlength="2"
          maxlength="100"
          required={this.props.required}
          className={this.props.className}
          value={this.props.value}
          onUpdate={this.props.onUpdate}
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          onFocus={this.props.onFocus}
          setToUpperCaseOnBlur
        />
      </div>
    );
  }
}

County.defaultProps = {
  name: 'county',
  value: '',
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
  required: false,
};

County.errors = [];
